export default __webpack_public_path__ + "54a352e64b94a2713dfcc77b71c69efc.png";